import { useCallback, useEffect, useState } from 'react';
import useInterval from 'src/hooks/useInterval';

/**
 * Handles showing dev utils on mobile based on user interaction.
 */
export default function useSettingsModalDevForm() {
	const [devTaps, setDevTaps] = useState<number>(0);
	const [showMobileDevForm, setShowMobileDevForm] = useState(false);

	useInterval(() => {
		if (devTaps > 0) {
			setDevTaps(0);
		}
	}, 3000);

	useEffect(() => {
		if (devTaps >= 5) {
			setShowMobileDevForm(true);
		}
	}, [devTaps]);

	const handleSettingsClick = useCallback(() => {
		setDevTaps(devTaps + 1);
	}, [devTaps]);

	const closeDevForm = useCallback(() => {
		setShowMobileDevForm(false);
	}, []);

	return {
		handleSettingsClick,
		showMobileDevForm,
		closeDevForm,
	};
}
